import React from 'react';
import FormItemButtonBaseControl from './FormItemButtonBaseControl';
import FormItemMenuItemButton from '../FormItemMenuItemButton';
import FormItemUtil from '../../utils/FormItemUtil';
import FormLoadHelper from '../../utils/FormLoadHelper';
import GOTUtil from '../../utils/GOTUtil';
import GOT from '../../utils/GOT';
import RecordsActions from '../../actions/RecordsActions';
import CmdTypeActions from '../../actions/CmdTypeActions';
import ArgCallerType from '../../forms/sys/ArgCallerType';
import GongqiFormItem from '../GongqiFormItem';

export default class FormItemMenuItemButtonControl extends FormItemButtonBaseControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemMenuItemButtonControl";
	}

	getStyle()
	{
		let _style = {};
		let layout = this.parentXML.Properties.Layout.Value;
		let parentType = this.parentXML.type;
		if(parentType == "ButtonGroup" && layout == "vertical")
		{
			_style["alignSelf"] = 'stretch';
		}
		//宽度高度的设置 其余都是在component中
		_style["padding"] = "1px 6px";

		let _width = this.xml.Properties.Width.Value;
		let _height =this.xml.Properties.Height.Value;

		if(_width)_style["width"] = _width+"px";
		if(_height)_style["height"] = _height+"px";

		return _style;
	}

	getProperty_MenuItem()
	{
		return this.properties.MenuItem;
	}

	getProperty_Label(showLabel = true)
	{
		if(this.properties.Label)
			return this.properties.Label;
		var result = GOTUtil.getPropertyValue(this.xml, "Label");
		if(result=="")
		{
			var property = GOTUtil.getProperty(this.xml, "MenuItem");
			if(property.hasOwnProperty("refentityid"))
			{
				var menuItem = GOT.getMenuItem(property.refentityid);
				result = GOTUtil.getPropertyValue(menuItem, "Label");
			}

		}
		if(result=="")
			result = this.xml.name;
		
		return result;
	}

	doOpenRelateForm(e)
	{
		var menuItemProStr = this.getProperty_MenuItem();
		var domParser = new DOMParser();
		var xmlDoc = domParser.parseFromString(menuItemProStr,"text/xml");
		var _xml = xmlDoc.childNodes[0];
		var refEntityId = null;//TODO 属性兼容
		if(_xml && _xml.attributes)
		{
			for(let i = 0;i<_xml.attributes.length;i++)
			{
				var att = _xml.attributes[i];
				if(att.nodeName == "refentityid")
				{
					refEntityId = att.nodeValue;
					break;
				}
			}
		}
		
		if(!refEntityId)
			refEntityId = menuItemProStr;
		if(!refEntityId)
			return;
		var menuItem = GOT.getMenuItem(refEntityId);
		if(!menuItem)
			return;
		//TODO 完善传给Manual画面的参数
		var commandArg = null;
		// if(menuItem.Properties.LoadType && menuItem.Properties.LoadType == "Manual")
		if(menuItem.name == "SysAuthoritySetup")
		{
			commandArg = {currentRecord:this.group?this.group.currentRecord:null};	
		}
		
		FormLoadHelper.openMenuItemByAuthority({menuItemId:menuItem.id,fm:window.formModuleInstance,
													group:this.group,callerKey:this.controlId,commandArg:commandArg});
		return;
		// if(!menuItemPro.hasOwnProperty("@refentityid"))
		// 	return ;
		// var menuItemId:String = String(menuItemPro.@refentityid);
		// FormLoadHelper.openMenuItemByAuthority(menuItemId, null, this.formDesign.formModule, this.group, null,controlId);

		var argCaller = {};
		argCaller.type = ArgCallerType.FormModule;
	    argCaller.callerType = "FormModule";
		argCaller.callerFormId = window.formId;
		argCaller.callerFormInstanceUUId = window.formModuleInstanceuuId;
	    argCaller.callerMenuItemId = window.menuItemId;
	    argCaller.callerKey = FormItemUtil.getFormModuleCallerKey(this.menuItemId,this.xml.id);
	    argCaller.parm = "parm";
	    argCaller.joinGroupAlias = this.groupAlias;
	    argCaller.joinTableName = this.group!=null?this.group.mainSource.tableName:null;
	    argCaller.joinRecord = this.group!=null?this.group.currentRecord:null;
	    //alert(JSON.stringify(argCaller.joinRecord));
	    var _parentWindow = window.parent.window;
		if(_parentWindow)
		{
			if(typeof(_parentWindow.openMenuItem)=='function')
			{
				console.log(this.getProperty_MenuItem());
				//TODO 根据menuItem属性对应的menuItemId 找到MenuItem 进而找到formId
				_parentWindow.openMenuItem("40000003",argCaller);
			}
		}
	}

	openRelateForm(e,isShortCut = false)
	{
		if(event.target)
		{
			if($(event.target).hasClass("disabled") || $(event.target).parent().hasClass("disabled"))
				return;
		}
		if(this.forLookup)
		{
			this.doOpenRelateForm(e);
			return;
		}
		if(typeof(isShortCut)=="object")
			isShortCut = false;
		var currentGroup = window.formModuleInstance.formDataSources.currentGroup;
		
		if(currentGroup == this.group)
		{
			if(this.getProperty_SaveRecord() && currentGroup)
			{
				if(this.getProperty_SaveRecord())
				{
					RecordsActions.RecordAutoSave(this.group.groupAlias);
				    if(window.rowChangeAutoSaveFail == true)
				    {
				      	//借用自动换行自动保存失败的标识
				        window.rowChangeAutoSaveFail = false;
				        return false;
				    }
				    this.doOpenRelateForm(e);
				}
			
			}
			else if(!currentGroup)
			{
				this.doOpenRelateForm(e);
			}
			else
			{
				this.doOpenRelateForm(e);
			}
		}
		else
		{
			if(currentGroup)
			{
				//alert("自动保存了");
				RecordsActions.RecordAutoSave(currentGroup.groupAlias);
				this.doOpenRelateForm(e);
			}
			else
			{
				//鼠标点击切换 快捷键不切换
				if(isShortCut)
					this.doOpenRelateForm(e);	
				if(this.parentControl && this.parentControl.classAlias == "FormItemButtonMenuControl")
				{
					this.doOpenRelateForm(e);	
				}
			}
		}
	}

	doSetEnableCmd(value)
	{
		this._cmdEditFalse = !value;
		CmdTypeActions.updateControlAllowEdit(this.xml.name,value,this.module.instanceUUId);
	}


	getJqueryItemUnderButtonMenu()
	{
		let $li = $("<li>");
		let $a = $("<a>").html(this.getProperty_Label()).click(this.openRelateForm.bind(this));
		let allowEdit = this.getProperty_AllowEdit_Final();
		let visible = this.getProperty_Visible_Final();
		if(!allowEdit)$li.addClass("disabled").css({opacity:0.5});
		if(!visible)$li.css("display","none");
		$li.attr("componentName",this.xml.name);
		$li.attr("controlId",this.controlId);
		return $li.append($a);
	}
	
	getComponentInstance(parent,forLookup)
	{
		let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
		let layout = parent.Properties.Layout.Value;
		let commonProps = this.getCommonProps();
	  	this.component = <FormItemMenuItemButton key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId}  
                parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} iconClass={this.getProperty_Icon()}
                label={label} customStyle={this.getStyle()} menuItemId={this.menuItemId} 
                formId={this.formId} clickHandler={this.openRelateForm.bind(this)} control={this}
                {...commonProps}/>;
        return this.component;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemMenuItemButtonControl.js